import { render, staticRenderFns } from "./bekijkVoorstel.vue?vue&type=template&id=3e6a67ab&"
import script from "./bekijkVoorstel.vue?vue&type=script&lang=js&"
export * from "./bekijkVoorstel.vue?vue&type=script&lang=js&"
import style0 from "./bekijkVoorstel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports